// todo  枚举 字典
import Vue from "vue";
(function() {
  // todo  调用：Vue.prototype.dict.xxx
  Vue.prototype.dict = {
    orderTimeSelect: [
      { code: "1-3", name: "近三个月" },
      { code: "1-6", name: "近半年" },
      { code: "1-12", name: "今年内" },
      { code: "1-36", name: "三年内" }
    ],
    // 企业订单
    orderStatusSelect: [
      { code: "5-", name: "所有状态" },
      { code: "5-0", name: "未生效" },
      { code: "5-2", name: "待确认" },
      { code: "5-3", name: "待发货" },
      { code: "5-4", name: "待收货" },
      { code: "5-5", name: "已完成" },
      { code: "5-6", name: "已取消" }
    ],
    // 企业订单全部
    orderStatusSelectAll: [
      { code: "5-", name: "所有状态" },
      { code: "5-0", name: "未生效" },
      { code: "5-2", name: "待确认" },
      { code: "5-3", name: "待发货" },
      { code: "5-4", name: "待收货" },
      { code: "5-5", name: "已完成" },
      { code: "5-6", name: "已取消" }
      // { code: '5-7', name: '失败' }
    ],
    // 个人字典项
    orderPersonStatusSelect: [
      { code: "5-0", name: "所有状态" },
      { code: "5-1", name: "待付款" },
      { code: "5-3", name: "待发货" },
      { code: "5-4", name: "待收货" },
      { code: "5-5", name: "已完成" },
      { code: "5-6", name: "已取消" }
    ],
    orderPersonStatusSelectAll: [
      { code: "5-0", name: "所有状态" },
      { code: "5-1", name: "待付款" },
      { code: "5-3", name: "待发货" },
      { code: "5-4", name: "待收货" },
      { code: "5-5", name: "已完成" },
      { code: "5-6", name: "已取消" }
    ],
    payType: [
      { value: 0, label: "企业支付" },
      { value: 1, label: "个人支付" }
    ],
    billStatusDict: [
      { value: null, label: "全部" },
      { value: 1, label: "待对账" },
      { value: 2, label: "已对账" }
    ],
    billStatus: ["待发送", "待对账", "已对账"], // 控制撤销按钮状态
    billType: ["系统出账", "手工出账"],
    orderSource: [
      { value: null, label: "全部" },
      { value: 3, label: "商城订单" },
      { value: 1, label: "协议订单" }
    ],
    payOutType: [
      {
        url: "/settlementManagement/payout",
        label: "待出账账单"
      }, // 0 待出账， 1 待发送， 2 已发送, 3 待对账, 4 已对账
      {
        url: "/settlementManagement/payout/stay-send-bill-list",
        label: "待发送账单"
      },
      {
        url: "/settlementManagement/payout/done-send-bill-list",
        label: "已发送账单"
      },
      {
        url: "/settlementManagement/reconciliation",
        label: "待对账账单"
      },
      {
        url: "/settlementManagement/reconciliation/bill-done-list",
        label: "已对账账单"
      }
    ],
    invoiceApplyTypeList: ["开票申请", "换票申请"],
    invoiceTypeLIst: [
      "增值税电子普通发票",
      "增值税普通发票",
      "增值税专用发票（纸质）",
      "增值税电子专用发票"
    ],
    orderType: [
      { label: "全部", value: "" },
      { label: "企业订单", value: 1 },
      { label: "个人订单", value: 2 }
    ],
    orderAfterStatus: [
      { code: "5-0", name: "全部状态" },
      { code: "5-1", name: "待审核" },
      { code: "5-2", name: "审核不通过" },
      { code: "5-3", name: "审核通过" },
      { code: "5-4", name: "待商家收货" },
      { code: "5-8", name: "待商家处理" },
      { code: "5-9", name: "待商家发货" },
      { code: "5-10", name: "待买家收货" },
      { code: "5-11", name: "已妥投" },
      { code: "5-5", name: "待售后确认" },
      { code: "5-6", name: "已完成" },
      { code: "5-7", name: "已取消" }
    ]
  };
})();
